import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const BackArrowThin = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props} fontSize='large'>
      <path
        d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
        strokeWidth="2px"
        fill="currentColor"
      />
    </SvgIcon>
);
